module.exports = __webpack_public_path__ + "static/media/stijn-bessem-portfolio-digital-mountain-back-2560x400.34e0b6c1.png";